// =========================================
// BELT PDP SCRIPT - Optimized with Metafield (V2.6.13)
// =========================================

// Utility: Get variant ID from URL with fetch counter
let variantFetchCount = 0;
function getVariantIdFromUrl() {
  const variantId = new URLSearchParams(window.location.search).get("variant");
  console.log(`🔍 Retrieved Variant ID from URL (#${++variantFetchCount}):`, variantId);
  return variantId;
}

// Function to fade out the preloader and show content
function removePreloader() {
  $("#preloader").fadeOut(250, function () {
    $("#content").fadeIn(250);
  });
}

// Function to fetch thread colors metafield with retry mechanism
function fetchThreadColorsForBelt(variantId, callback, retryCount = 0) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';
  const shopName = 'blue-delta-jeans';
  const maxRetries = 2;
  const retryDelay = 1000; // 1 second delay between retries

  if (!variantId) {
    console.warn('⚠️ No variant ID provided to fetch thread_colors metafield.');
    callback(null);
    return;
  }

  console.log('Fetching thread colors for variant:', variantId);

  const query = `
    {
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          metafield(namespace: "custom", key: "thread_colors") {
            value
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => {
    console.log('Fetch response status for thread_colors:', response.status, response.statusText);
    return response.json();
  })
  .then(data => {
    console.log('Detailed API Response for thread_colors metafield:', JSON.stringify(data, null, 2));
    if (!data.data || !data.data.node) {
      console.warn('⚠️ Variant not found or inaccessible for ID:', variantId);
      if (retryCount < maxRetries) {
        console.log(`Retrying fetchThreadColorsForBelt (attempt ${retryCount + 1}/${maxRetries})...`);
        setTimeout(() => fetchThreadColorsForBelt(variantId, callback, retryCount + 1), retryDelay);
      } else {
        console.warn('Max retries reached for fetching thread_colors metafield.');
        $('.selectedThreadName').text(': Variant unavailable');
        callback(null);
      }
      return;
    }
    const threadColorsMetafield = data.data.node.metafield;
    if (threadColorsMetafield && threadColorsMetafield.value) {
      const threadColorsGIDs = JSON.parse(threadColorsMetafield.value);
      fetchMatchingThreadImage(threadColorsGIDs, callback);
    } else {
      console.warn('⚠️ No thread_colors metafield found for this variant.');
      if (retryCount < maxRetries) {
        console.log(`Retrying fetchThreadColorsForBelt (attempt ${retryCount + 1}/${maxRetries})...`);
        setTimeout(() => fetchThreadColorsForBelt(variantId, callback, retryCount + 1), retryDelay);
      } else {
        console.warn('Max retries reached for fetching thread_colors metafield.');
        $('.selectedThreadName').text(': No thread colors available');
        callback(null);
      }
    }
  })
  .catch(error => {
    console.log('Error fetching thread colors metafield:', error);
    if (retryCount < maxRetries) {
      console.log(`Retrying fetchThreadColorsForBelt (attempt ${retryCount + 1}/${maxRetries})...`);
      setTimeout(() => fetchThreadColorsForBelt(variantId, callback, retryCount + 1), retryDelay);
    } else {
      console.warn('Max retries reached for fetching thread_colors metafield.');
      $('.selectedThreadName').text(': Error fetching data');
      callback(null);
    }
  });
}

// Function to fetch style images metafield
function fetchStyleImagesForBelt(variantId, callback) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';
  const shopName = 'blue-delta-jeans';

  if (!variantId) {
    console.warn('⚠️ No variant ID provided to fetch style_media metafield.');
    callback(null, null);
    return;
  }

  console.log('Fetching style images for variant:', variantId);

  const query = `
    {
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          metafield(namespace: "custom", key: "style_media") {
            value
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => {
    console.log('Fetch response status for style_media:', response.status, response.statusText);
    return response.json();
  })
  .then(data => {
    console.log('API Response for style_media metafield:', data);
    if (!data.data || !data.data.node) {
      console.warn('⚠️ Variant not found or inaccessible for ID:', variantId);
      callback(null, null);
      return;
    }
    const styleMediaMetafield = data.data.node.metafield;
    if (styleMediaMetafield && styleMediaMetafield.value) {
      const mediaGIDs = JSON.parse(styleMediaMetafield.value);
      console.log('Parsed media GIDs:', mediaGIDs);
      // Fetch the image URLs
      const queryImages = `
        {
          nodes(ids: ${JSON.stringify(mediaGIDs)}) {
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
      `;

      fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken
        },
        body: JSON.stringify({ query: queryImages })
      })
      .then(response => response.json())
      .then(imageData => {
        console.log('Raw API Response for style media URLs:', imageData);
        let firstImage = null;
        let secondImage = null;

        // Adjusted to only require one image since we're only loading varImage1
        if (imageData && imageData.data && imageData.data.nodes && imageData.data.nodes.length >= 1) {
          console.log('Nodes array:', imageData.data.nodes);
          firstImage = imageData.data.nodes[0] && imageData.data.nodes[0].image ? imageData.data.nodes[0].image.url : null;
          // No longer need secondImage, but keeping it in cache for potential future use
          secondImage = imageData.data.nodes[1] && imageData.data.nodes[1].image ? imageData.data.nodes[1].image.url : null;
          console.log('Extracted URLs:', { firstImage, secondImage });
        } else {
          console.warn('Unexpected structure in style media URLs response or insufficient nodes:', imageData);
        }

        callback(firstImage, secondImage);
      })
      .catch(error => {
        console.log('Error fetching style media URLs:', error);
        callback(null, null);
      });
    } else {
      console.warn('⚠️ No style_media metafield found for this variant.');
      callback(null, null);
    }
  })
  .catch(error => {
    console.log('Error fetching style_media metafield:', error);
    callback(null, null);
  });
}

// Function to return a static default variant ID
function fetchDefaultVariantId(callback) {
  const defaultVariantId = '53561472680227';
  console.log('Using static default variant ID:', defaultVariantId);
  callback(defaultVariantId);
}

// Function to fetch and match the image based on selected thread color
function fetchMatchingThreadImage(mediaGIDs, callback) {
  const storefrontAccessToken = '467c76bf7b9f52672e21403f810e9de3';
  const shopName = 'blue-delta-jeans';

  const query = `
    {
      nodes(ids: ${JSON.stringify(mediaGIDs)}) {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
  `;

  fetch(`https://${shopName}.myshopify.com/api/2023-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
  .then(response => {
    console.log('Fetch response status for thread media URLs:', response.status, response.statusText);
    return response.json();
  })
  .then(data => {
    console.log('API Response for thread media URLs:', data);
    // Get selected thread color (fully lowercase, including suffix)
    let thread = $('.bold_option_value_element input[type="checkbox"]:checked')
      .val()?.toLowerCase().replace(/\s+/g, "") || "nothread";
    // Map "No Thread" option to "nothread" explicitly, otherwise add "t" suffix
    if (thread === "nothread") {
      thread = "nothread";
    } else {
      thread = thread + "t";
    }
    console.log('Looking for thread color in filename:', thread);

    // Log buckle variant for debugging
    let buckle = $('.option-item-inner[option-name="Buckle"].selected')
      .attr("option-name-value")
      ?.toLowerCase()
      .replace(/\s+/g, "") || "flat";
    // Replace "antiquebrass" with "brass" to match filenames
    buckle = buckle.replace("antiquebrass", "brass");
    buckle = buckle + "B";
    console.log('Selected buckle variant:', buckle);

    // Log available filenames for debugging
    const availableFilenames = [];
    let matchingUrl = null;
    let firstAvailableUrl = null;

    if (data.data && data.data.nodes) {
      data.data.nodes.forEach(function(mediaNode) {
        if (mediaNode && mediaNode.image && mediaNode.image.url) {
          const filename = mediaNode.image.url.split('/').pop().split('.').shift();
          const filenameLower = filename.toLowerCase(); // Convert filename to lowercase for case-insensitive comparison
          availableFilenames.push(filename);
          if (!firstAvailableUrl) {
            firstAvailableUrl = mediaNode.image.url; // Store the first image as a fallback
          }
          if (filenameLower.includes(thread)) { // Case-insensitive match
            matchingUrl = mediaNode.image.url;
          }
        }
      });
    }

    console.log('Available filenames in metafield:', availableFilenames);

    if (matchingUrl) {
      console.log('Matching belt image found based on thread color:', matchingUrl);
      callback(matchingUrl);
    } else {
      console.log('No image found containing thread color:', thread);
      // Fallback: Use strict filename matching as a backup (case-insensitive)
      // Use width "1" to match example filename (e.g., 1-footballL-nothread-brassB.jpg)
      const width = thread === "nothread" ? '1' : '15';
      const leather = $('.option-item-inner[option-name="Leather"].selected')
        .attr("option-name-value")
        ?.toLowerCase()
        .replace(/\s+/g, "") || "black";
      const expectedFilename = `${width}-${leather}l-${thread}-${buckle}`.toLowerCase(); // Fully lowercase
      console.log('Falling back to strict filename match:', expectedFilename);

      let strictMatchUrl = null;
      if (data.data && data.data.nodes) {
        data.data.nodes.forEach(function(mediaNode) {
          if (mediaNode && mediaNode.image && mediaNode.image.url) {
            const filename = mediaNode.image.url.split('/').pop().split('.').shift();
            const filenameLower = filename.toLowerCase(); // Case-insensitive comparison
            if (filenameLower === expectedFilename) {
              strictMatchUrl = mediaNode.image.url;
            }
          }
        });
      }

      if (strictMatchUrl) {
        console.log('Strict match found:', strictMatchUrl);
        callback(strictMatchUrl);
      } else if (firstAvailableUrl) {
        console.log('No strict match, falling back to first available image:', firstAvailableUrl);
        callback(firstAvailableUrl);
      } else {
        callback(null);
      }
    }
  })
  .catch(error => {
    console.log('Error fetching thread media URLs:', error);
    callback(null);
  });
}

// Global: Belt Thread Change Handler (for inline onmouseup)
function beltThreadChange(element) {
  console.log("🧵 Belt threadChange triggered");

  // Determine the selected thread color
  let selectedColor;
  if (element) {
    // Called from onmouseup event
    selectedColor = $(element)
      .closest(".bold_option_value_element")
      .find('input[type="checkbox"]')
      .val()
      ?.trim();
  } else {
    // Called programmatically (e.g., on page load)
    const $selectedThread = $('.bold_option_value_element input[type="checkbox"]:checked');
    selectedColor = $selectedThread.length ? $selectedThread.val()?.trim() : "No Thread"; // Default to "No Thread"
  }

  if (!selectedColor) {
    console.warn("❌ No thread color found.");
    selectedColor = "No Thread"; // Default to "No Thread" if no selection
  }

  console.log("🎨 Selected Thread Color:", selectedColor);
  $(".pdp2024 .prodThreadSpools .selectedThreadName").text(": " + selectedColor);

  // Add green checkmark for thread selection
  if (element) {
    const $threadElement = $(element).closest(".bold_option_value_element");
    // Remove checkmark from other thread options
    $('.bold_option_value_element').not($threadElement).find('.greenOptionIndicator').remove();
    // Add checkmark to the selected thread option
    $threadElement.find('.greenOptionIndicator').remove(); // Remove any existing checkmark
    $threadElement.css('position', 'relative');
    const checkmark = $('<div class="greenOptionIndicator" style="width:15px; height:15px; position: absolute; left:0; bottom:8px;"><img style="width:100%;" src="https://cdn.shopify.com/s/files/1/0056/9189/9977/files/check-indicator-green.svg"></div>');
    $threadElement.append(checkmark);
  }

  let variantId = getVariantIdFromUrl();
  if (variantId) {
    fetchThreadColorsForBelt(variantId, function(imageUrl) {
      if (imageUrl) {
        $(".primaryBeltImg img").animate({ opacity: 0.25 }, 200, function() { // Fade to 25% opacity
          const imgElement = $(this);
          // Remove any existing preloaders before adding a new one
          imgElement.parent().find('.belt-primary-preloader').remove();
          const spinner = $('<div class="belt-primary-preloader"></div>');
          console.log('Adding belt-primary-preloader for fetched image');
          imgElement.parent().css('position', 'relative').append(spinner);

          const tempImg = new Image();
          tempImg.src = imageUrl;

          const minSpinnerTime = 300; // Minimum time to show spinner (500ms)

          // Promise to wait for image load
          const imageLoadPromise = new Promise((resolve, reject) => {
            tempImg.onload = () => resolve(true);
            tempImg.onerror = () => reject(new Error('Image load failed'));
          });

          // Promise to enforce minimum spinner display time
          const spinnerDelayPromise = new Promise((resolve) => {
            setTimeout(() => resolve(true), minSpinnerTime);
          });

          // Wait for both the image to load (or fail) and the minimum spinner time
          Promise.allSettled([imageLoadPromise, spinnerDelayPromise]).then(([imageResult]) => {
            imgElement.attr('src', imageUrl);
            console.log('Removing belt-primary-preloader for fetched image');
            spinner.remove();
            imgElement.animate({ opacity: 1 }, 500);
          }).catch((error) => {
            console.error('Error loading fetched image:', error.message);
            console.log('Removing belt-primary-preloader due to image load error');
            spinner.remove();
            imgElement.animate({ opacity: 1 }, 500);
          });
        });
      } else {
        // Fallback to default image
        const defaultImage = 'https://cdn.shopify.com/s/files/1/0056/9189/9977/files/15-blackL-blackT_flat.jpg';
        console.log('Using default image:', defaultImage);
        $(".primaryBeltImg img").animate({ opacity: 0.25 }, 200, function() { // Fade to 25% opacity
          const imgElement = $(this);
          // Remove any existing preloaders before adding a new one
          imgElement.parent().find('.belt-primary-preloader').remove();
          const spinner = $('<div class="belt-primary-preloader"></div>');
          console.log('Adding belt-primary-preloader for default image');
          imgElement.parent().css('position', 'relative').append(spinner);

          const tempImg = new Image();
          tempImg.src = defaultImage;

          const minSpinnerTime = 500; // Minimum time to show spinner (500ms)

          // Promise to wait for image load
          const imageLoadPromise = new Promise((resolve, reject) => {
            tempImg.onload = () => resolve(true);
            tempImg.onerror = () => reject(new Error('Image load failed'));
          });

          // Promise to enforce minimum spinner display time
          const spinnerDelayPromise = new Promise((resolve) => {
            setTimeout(() => resolve(true), minSpinnerTime);
          });

          // Wait for both the image to load (or fail) and the minimum spinner time
          Promise.allSettled([imageLoadPromise, spinnerDelayPromise]).then(([imageResult]) => {
            imgElement.attr('src', defaultImage);
            console.log('Removing belt-primary-preloader for default image');
            spinner.remove();
            imgElement.animate({ opacity: 1 }, 300);
          }).catch((error) => {
            console.error('Error loading default image:', error.message);
            console.log('Removing belt-primary-preloader due to image load error');
            spinner.remove();
            imgElement.animate({ opacity: 1 }, 300);
          });
        });
      }

      // Load style image independently of the primary image
      let variantIdInner = getVariantIdFromUrl(); // Renamed to avoid shadowing
      console.log('Attempting to load style images with variantId:', variantIdInner);
      if (variantIdInner) {
        fetchStyleImagesForBelt(variantIdInner, function(firstImage, secondImage) {
          console.log('Style images fetched:', { firstImage, secondImage });
          const varImage1 = $(".varImage1 img");
          if (varImage1.length) {
            if (firstImage) {
              varImage1.attr('src', firstImage);
              console.log('Set .varImage1 img src to:', firstImage);
            } else {
              console.warn('No first image returned from custom.style_media for .varImage1');
            }
          } else {
            console.warn('Element .varImage1 img not found in DOM');
          }
        });
      } else {
        console.warn('No variantId available to fetch style images');
      }
    });
  } else {
    console.log('No variant ID found in URL, attempting to fetch a default variant ID.');
    fetchDefaultVariantId(function(defaultVariantId) {
      if (defaultVariantId) {
        fetchThreadColorsForBelt(defaultVariantId, function(imageUrl) {
          if (imageUrl) {
            $(".primaryBeltImg img").animate({ opacity: 0.25 }, 200, function() { // Fade to 25% opacity
              const imgElement = $(this);
              // Remove any existing preloaders before adding a new one
              imgElement.parent().find('.belt-primary-preloader').remove();
              const spinner = $('<div class="belt-primary-preloader"></div>');
              console.log('Adding belt-primary-preloader for default variant image');
              imgElement.parent().css('position', 'relative').append(spinner);

              const tempImg = new Image();
              tempImg.src = imageUrl;

              const minSpinnerTime = 500; // Minimum time to show spinner (500ms)

              // Promise to wait for image load
              const imageLoadPromise = new Promise((resolve, reject) => {
                tempImg.onload = () => resolve(true);
                tempImg.onerror = () => reject(new Error('Image load failed'));
              });

              // Promise to enforce minimum spinner display time
              const spinnerDelayPromise = new Promise((resolve) => {
                setTimeout(() => resolve(true), minSpinnerTime);
              });

              // Wait for both the image to load (or fail) and the minimum spinner time
              Promise.allSettled([imageLoadPromise, spinnerDelayPromise]).then(([imageResult]) => {
                imgElement.attr('src', imageUrl);
                console.log('Removing belt-primary-preloader for default variant image');
                spinner.remove();
                imgElement.animate({ opacity: 1 }, 500);
              }).catch((error) => {
                console.error('Error loading default variant image:', error.message);
                console.log('Removing belt-primary-preloader due to image load error');
                spinner.remove();
                imgElement.animate({ opacity: 1 }, 500);
              });
            });
          } else {
            const defaultImage = 'https://cdn.shopify.com/s/files/1/0056/9189/9977/files/15-blackL-blackT_flat.jpg';
            console.log('Using default image:', defaultImage);
            $(".primaryBeltImg img").animate({ opacity: 0.25 }, 200, function() { // Fade to 25% opacity
              const imgElement = $(this);
              // Remove any existing preloaders before adding a new one
              imgElement.parent().find('.belt-primary-preloader').remove();
              const spinner = $('<div class="belt-primary-preloader"></div>');
              console.log('Adding belt-primary-preloader for fallback default image');
              imgElement.parent().css('position', 'relative').append(spinner);

              const tempImg = new Image();
              tempImg.src = defaultImage;

              const minSpinnerTime = 500; // Minimum time to show spinner (500ms)

              // Promise to wait for image load
              const imageLoadPromise = new Promise((resolve, reject) => {
                tempImg.onload = () => resolve(true);
                tempImg.onerror = () => reject(new Error('Image load failed'));
              });

              // Promise to enforce minimum spinner display time
              const spinnerDelayPromise = new Promise((resolve) => {
                setTimeout(() => resolve(true), minSpinnerTime);
              });

              // Wait for both the image to load (or fail) and the minimum spinner time
              Promise.allSettled([imageLoadPromise, spinnerDelayPromise]).then(([imageResult]) => {
                imgElement.attr('src', defaultImage);
                console.log('Removing belt-primary-preloader for fallback default image');
                spinner.remove();
                imgElement.animate({ opacity: 1 }, 300);
              }).catch((error) => {
                console.error('Error loading fallback default image:', error.message);
                console.log('Removing belt-primary-preloader due to image load error');
                spinner.remove();
                imgElement.animate({ opacity: 1 }, 300);
              });
            });
          }

          // Load style image independently of the primary image
          let variantIdInner = defaultVariantId; // Renamed to avoid shadowing
          console.log('Attempting to load style images with variantId:', variantIdInner);
          if (variantIdInner) {
            fetchStyleImagesForBelt(variantIdInner, function(firstImage, secondImage) {
              console.log('Style images fetched:', { firstImage, secondImage });
              const varImage1 = $(".varImage1 img");
              if (varImage1.length) {
                if (firstImage) {
                  varImage1.attr('src', firstImage);
                  console.log('Set .varImage1 img src to:', firstImage);
                } else {
                  console.warn('No first image returned from custom.style_media for .varImage1');
                }
              } else {
                console.warn('Element .varImage1 img not found in DOM');
              }
            });
          } else {
            console.warn('No variantId available to fetch style images');
          }
        });
      } else {
        const defaultImage = 'https://cdn.shopify.com/s/files/1/0056/9189/9977/files/15-blackL-blackT_flat.jpg';
        console.log('Using default image:', defaultImage);
        $(".primaryBeltImg img").animate({ opacity: 0.25 }, 200, function() { // Fade to 25% opacity
          const imgElement = $(this);
          // Remove any existing preloaders before adding a new one
          imgElement.parent().find('.belt-primary-preloader').remove();
          const spinner = $('<div class="belt-primary-preloader"></div>');
          console.log('Adding belt-primary-preloader for final fallback image');
          imgElement.parent().css('position', 'relative').append(spinner);

          const tempImg = new Image();
          tempImg.src = defaultImage;

          const minSpinnerTime = 500; // Minimum time to show spinner (500ms)

          // Promise to wait for image load
          const imageLoadPromise = new Promise((resolve, reject) => {
            tempImg.onload = () => resolve(true);
            tempImg.onerror = () => reject(new Error('Image load failed'));
          });

          // Promise to enforce minimum spinner display time
          const spinnerDelayPromise = new Promise((resolve) => {
            setTimeout(() => resolve(true), minSpinnerTime);
          });

          // Wait for both the image to load (or fail) and the minimum spinner time
          Promise.allSettled([imageLoadPromise, spinnerDelayPromise]).then(([imageResult]) => {
            imgElement.attr('src', defaultImage);
            console.log('Removing belt-primary-preloader for final fallback image');
            spinner.remove();
            imgElement.animate({ opacity: 1 }, 300);
          }).catch((error) => {
            console.error('Error loading final fallback image:', error.message);
            console.log('Removing belt-primary-preloader due to image load error');
            spinner.remove();
            imgElement.animate({ opacity: 1 }, 300);
          });
        });

        // Load style image independently of the primary image
        let variantIdInner = getVariantIdFromUrl(); // Renamed to avoid shadowing
        console.log('Attempting to load style images with variantId:', variantIdInner);
        if (variantIdInner) {
          fetchStyleImagesForBelt(variantIdInner, function(firstImage, secondImage) {
            console.log('Style images fetched:', { firstImage, secondImage });
            const varImage1 = $(".varImage1 img");
            if (varImage1.length) {
              if (firstImage) {
                varImage1.attr('src', firstImage);
                console.log('Set .varImage1 img src to:', firstImage);
              } else {
                console.warn('No first image returned from custom.style_media for .varImage1');
              }
            } else {
              console.warn('Element .varImage1 img not found in DOM');
            }
          });
        } else {
          console.warn('No variantId available to fetch style images (default case)');
        }
      }
    });
  }
}

// Store original buckle image src values
const originalBuckleImages = {
  antiqueBrass: '',
  nickel: '',
  flatBlack: ''
};

$(document).ready(function () {
  try {
    // Store the original src values of the buckle images
    originalBuckleImages.antiqueBrass = $("#value-wrapper-Buckle-Antique\\ Brass img").attr('src') || '';
    originalBuckleImages.nickel = $("#value-wrapper-Buckle-Nickel img").attr('src') || '';
    originalBuckleImages.flatBlack = $("#value-wrapper-Buckle-Flat\\ Black img").attr('src') || '';
    console.log('Stored original buckle image src values:', originalBuckleImages);

    // Assign thread swatch click using onmouseup (passing the element)
    setTimeout(() => {
      $(".bold_option_value_element").each(function() {
        $(this).attr("onmouseup", "beltThreadChange(this)");
      });
    }, 750);

    // Handle clicks on leather, hardware, width (always trigger image update)
    $('.option-item-inner').on('click', function () {
      const $el = $(this);
      const optionName = $el.attr("option-name");
      const optionValue = $el.attr("option-name-value");

      console.log(`🧩 CLICKED: ${optionName} → ${optionValue}`);

      const $group = $(`.option-item-inner[option-name="${optionName}"]`);
      $group.removeClass("selected").css({ /*transform: "scale(1)",*/ left: "", position: "" });
      $group.find('.greenOptionIndicator').remove(); // Remove checkmark from non-selected elements in the group
      $el.addClass("selected").css({ /*transform: "scale(1.08)",*/ transition: "left 0.2s ease" });

      // Apply width-specific styles if the option is Width
      //   if (optionName && optionName.toLowerCase() === "width") {
      //     $el.css({ left: "17px", position: "relative" });
      //   }

      // Add green checkmark for leather, width, or buckle options
      console.log('Checking if checkmark should be added for option:', optionName);
      if (optionName && ["leather", "width", "buckle"].includes(optionName.toLowerCase())) {
        console.log('Adding green checkmark for option:', optionName);
        $el.css('position', 'relative');
        // Use different positioning for buckle selections
        const checkmarkStyle = optionName.toLowerCase() === "buckle"
          ? 'width:15px; height:15px; position: absolute; left:20px; bottom:12px;'
          : 'width:15px; height:15px; position: absolute; left:0; bottom:8px;';
        const checkmark = $(`<div class="greenOptionIndicator" style="${checkmarkStyle}"><img style="width:100%;" src="https://cdn.shopify.com/s/files/1/0056/9189/9977/files/check-indicator-green.svg"></div>`);
        $el.append(checkmark);
      } else {
        console.log('Not adding green checkmark for option:', optionName);
      }

      // Debugging: Log to confirm we're entering the width logic
      console.log('Checking if optionName is Width:', { optionName, optionValue });

      // Update buckle images based on width selection (case-insensitive check)
      if (optionName && optionName.toLowerCase() === "width") {
        // Strip any surrounding quotes from optionValue
        const cleanOptionValue = optionValue.replace(/^"|"$/g, '');
        console.log(`Width option clicked: ${cleanOptionValue}`);

        // Check if buckle image elements exist
        const $antiqueBrassImg = $("#value-wrapper-Buckle-Antique\\ Brass img");
        const $nickelImg = $("#value-wrapper-Buckle-Nickel img");
        const $flatBlackImg = $("#value-wrapper-Buckle-Flat\\ Black img");
        console.log('Found buckle image elements:', {
          antiqueBrass: $antiqueBrassImg.length,
          nickel: $nickelImg.length,
          flatBlack: $flatBlackImg.length
        });

        if (cleanOptionValue === "1") {
          // Update to new buckle images for 1" width
          if ($antiqueBrassImg.length) {
            $antiqueBrassImg.attr('src', 'https://cdn.shopify.com/s/files/1/0056/9189/9977/files/brass-buckle-fix1.jpg');
            console.log('Updated Antique Brass buckle image src:', $antiqueBrassImg.attr('src'));
          } else {
            console.warn('Antique Brass buckle image not found in DOM');
          }
          if ($nickelImg.length) {
            $nickelImg.attr('src', 'https://cdn.shopify.com/s/files/1/0056/9189/9977/files/buckle-nickel-1in.jpg?v=1745986156');
            console.log('Updated Nickel buckle image src:', $nickelImg.attr('src'));
          } else {
            console.warn('Nickel buckle image not found in DOM');
          }
          if ($flatBlackImg.length) {
            $flatBlackImg.attr('src', 'https://cdn.shopify.com/s/files/1/0056/9189/9977/files/buckle-blk-1in.jpg?v=1745986156');
            console.log('Updated Flat Black buckle image src:', $flatBlackImg.attr('src'));
          } else {
            console.warn('Flat Black buckle image not found in DOM');
          }
          console.log('Updated buckle images for 1" width');
        } else if (cleanOptionValue === "1.25" || cleanOptionValue === "1.5") {
          // Revert to original buckle images for 1.25" or 1.5" width
          if ($antiqueBrassImg.length) {
            $antiqueBrassImg.attr('src', originalBuckleImages.antiqueBrass);
            console.log('Reverted Antique Brass buckle image src:', $antiqueBrassImg.attr('src'));
          } else {
            console.warn('Antique Brass buckle image not found in DOM');
          }
          if ($nickelImg.length) {
            $nickelImg.attr('src', originalBuckleImages.nickel);
            console.log('Reverted Nickel buckle image src:', $nickelImg.attr('src'));
          } else {
            console.warn('Nickel buckle image not found in DOM');
          }
          if ($flatBlackImg.length) {
            $flatBlackImg.attr('src', originalBuckleImages.flatBlack);
            console.log('Reverted Flat Black buckle image src:', $flatBlackImg.attr('src'));
          } else {
            console.warn('Flat Black buckle image not found in DOM');
          }
          console.log(`Reverted buckle images for ${cleanOptionValue}" width`);
        }
      } else {
        console.log('Not a Width option, skipping buckle image update');
      }

      // Always trigger image update on variant change
      beltThreadChange(); // Programmatic call without element
    });

    // Belt Monogram Checkbox Toggle
    $(".beltThreadSpools").on("change", "input[type='checkbox']", function () {
      const $beltMonogramCheckbox = $(".bold_option_title:contains('Belt Monogram')")
        .closest("label")
        .find("input[type='checkbox']");

      if ($beltMonogramCheckbox.length) {
        if ($beltMonogramCheckbox.prop("checked")) {
          $(".beltMonoImg").show();
          $(".mobileVarImage").show();
          console.log("✅ Belt Monogram Checked — Showing .beltMonoImg");
        } else {
          $(".beltMonoImg").hide();
          $(".mobileVarImage").hide();
          console.log("❌ Belt Monogram Unchecked — Hiding .beltMonoImg");
        }
      }
    });

    // // Run image update on page load (reduced delay to 1.75 seconds to speed up primary image load)
    // setTimeout(() => {
    //   console.log('Starting initial beltThreadChange after 1.75 seconds');
    //   beltThreadChange(); // Programmatic call without element
    // }, 1750);


  } catch (error) {
    console.error('Error in document.ready handler:', error);
  }

  // Preloader Handling: Remove preloader on window load or after 2 seconds, with a fallback after 5 seconds
  let preloaderTimeout = setTimeout(() => {
    console.log('Fading out preloader after 2 seconds (timeout)');
    removePreloader();
  }, 2000);

  let maxPreloaderTimeout = setTimeout(() => {
    console.log('Fading out preloader after 5 seconds (max timeout fallback)');
    removePreloader();
  }, 5000);

  $(window).on("load", function () {
    console.log('Window load event fired, fading out preloader');
    clearTimeout(preloaderTimeout);
    clearTimeout(maxPreloaderTimeout);
    removePreloader();
  });
});

// Hover popup on swatches
$(document).on('mouseenter', '.bold_option_value_swatch', function() {
  const $swatch = $(this);
  const swatchValue = $swatch.siblings('input[type="checkbox"]').val();

  const $popup = $('<div class="swatch-popup"></div>').text(swatchValue).css({
    position: 'absolute', backgroundColor: '#000', color: '#fff',
    padding: '5px 10px', borderRadius: '5px', marginLeft: '-20px',
    fontSize: '14px', zIndex: 1000, whiteSpace: 'nowrap'
  });

  $swatch.parent().css('position', 'relative');
  const swatchOffset = $swatch.offset();
  const swatchWidth = $swatch.outerWidth();

  $popup.css({
    top: swatchOffset.top - $popup.outerHeight() - 5,
    left: swatchOffset.left + (swatchWidth / 2) - ($popup.outerWidth() / 2)
  });

  $('body').append($popup);
});

$(document).on('mouseleave', '.bold_option_value_swatch', function() {
  $('.swatch-popup').remove();
});